'use strict';

AppController.$inject = [
  '$scope',
  '$ionicSideMenuDelegate',
];

export function AppController($scope, $ionicSideMenuDelegate) {
  $scope.toggleLeft = function () {
    $ionicSideMenuDelegate.toggleLeft();
  };
}



// WEBPACK FOOTER //
// ./src/js/app/AppController.js